import storeManager from '../store/StoreManager';
import sessionReader from '../store/readHelpers/SessionReader';
import * as hardwareRequirements from './HardwareRequirements';
import idVerificationService from './idverification/IdVerificationService';
import manualIdVerificationService from './manualidverification/ManualIdVerificationService';
import routeTypes from '../constants/RouteTypes';
import stateCacheService from './StateCache';
import remoteOralExamService from './RemoteOralExamService';
import readinessCheckService from './ReadinessCheckService';

const preCheckService = {
    readinessCheckCompleted() {
        return !sessionReader.hasReadinessCheck()
            || readinessCheckService.isReadinessCheckComplete();
    },

    audioVideoCheckCompleted() {
        return this.hardwareCheckCompleted() && this.zoomCallCheckCompleted();
    },

    hardwareCheckCompleted() {
        const { livestream } = storeManager.getState();
        return !hardwareRequirements.needsHardware()
            || hardwareRequirements.hardwareCheckIsComplete(livestream);
    },

    zoomCallCheckCompleted() {
        const { remoteOralExam } = storeManager.getState();
        const isCheckCallNeeded = sessionReader.isRemoteOralCallCheckEnabled() && !sessionReader.isWebRTCBasedRemoteSpeakingEnabled();
        return !isCheckCallNeeded
            || remoteOralExamService.isZoomTestCallConfirmed(remoteOralExam);
    },

    idVerificationCompleted() {
        const { idverification } = storeManager.getState();
        return !idVerificationService.needsIdVerification()
            || idVerificationService.isIdVerificationComplete(idverification);
    },

    manualIdVerificationCompleted() {
        const { idverification } = storeManager.getState();
        return !manualIdVerificationService.isManualIdVerificationNeeded()
            || manualIdVerificationService.isManualIdVerificationComplete(idverification);
    },

    roomScanCompleted() {
        const { livestream } = storeManager.getState();
        return !sessionReader.isRemoteProctoringRoomscanEnabled()
            || livestream.isRoomScanConfirmed
            || stateCacheService.getStateCacheInstance().isRoomScanConfirmed();
    },

    allShownChecksCompleted() {
        return this.readinessCheckCompleted()
            && this.audioVideoCheckCompleted()
            && this.idVerificationCompleted()
            && this.manualIdVerificationCompleted()
            && this.roomScanCompleted();
    },

    isPreCheckPage(routeType) {
        const isRoomScanPage = routeType === routeTypes.ROUTE_TYPE_ROOM_SCAN;
        const isIdVerificationPage = routeType === routeTypes.ROUTE_TYPE_ID_VERIFICATION;
        return isRoomScanPage || isIdVerificationPage;
    },
};

export default preCheckService;
